import { useContext } from "react";
import { ConfirmationContext } from "../providers/ConfirmationProvider";

export const useConfirm = () => {
    const context = useContext(ConfirmationContext);
    if (!context) {
      throw new Error("useConfirm must be used within a ConfirmationContext");
    }
    return context;
  };